import Swal from 'sweetalert2'
import {getIsSessionInvalidated} from "@/utils/logout";

/*
alert 관련 메시지 이벤트 저장 후 사용
 */

export default {
    methods: {
        createAlert(params){
            if (getIsSessionInvalidated()) {
                return;
            }
            Swal.fire({
                title: !params.title ? '' : params.title,
                html: !params.content ? '' : params.content,
                confirmButtonText: !params.btnText ? '확인' : params.btnText,
                customClass: !params.customClass ? 'alert-default' : params.customClass,
                didClose: () => {
                    if(params.back){
                        window.history.back();
                    }else if(params.hide) {
                        params.hide();
                    }
                }
            })
        },
        createConfirm(params){
            if (getIsSessionInvalidated()) {
                return;
            }
            Swal.fire({
                title: !params.title ? '' : params.title,
                html: !params.content ? '' : params.content,
                confirmButtonText: !params.confirmText ? '확인' : params.confirmText,
                cancelButtonText: !params.cancelText ?'취소' : params.cancelText,
                showCancelButton: true,
                customClass: !params.customClass ? 'alert-default confirm' : params.customClass,
                // showCloseButton: true,
                // allowOutsideClick: false,
            }).then((result) => {
                if (result.value) {
                    if(params.confirm)
                        params.confirm();
                } else if(result.dismiss === 'cancel') {
                    if(params.cancel)
                        params.cancel();
                }
            })
        },
        confirmLogout(confirm) {
            if (getIsSessionInvalidated()) {
                return;
            }
            this.createConfirm({
                title: '로그아웃 확인',
                content: '현재 계정이 로그인된 모든 기기에서 로그아웃됩니다.<br>로그아웃하시겠습니까?',
                cancelText: '닫기',
                confirmText: '로그아웃',
                confirm,
            })
        },

        deleteConfirm(params){
            if (getIsSessionInvalidated()) {
                return;
            }
            Swal.fire({
                title: !params.title ? '' : params.title,
                html: !params.content ? '' : params.content,
                confirmButtonText: !params.confirmText ? '삭제' : params.confirmText,
                cancelButtonText: !params.cancelText ?'취소' : params.cancelText,
                showCancelButton: true,
                customClass: !params.customClass ? 'alert-default delete' : params.customClass,
                // showCloseButton: true,
                // allowOutsideClick: false,
            }).then((result) => {
                if (result.value) {
                    if(params.confirm)
                        params.confirm();
                } else if(result.dismiss === 'cancel') {
                    if(params.cancel)
                        params.cancel();
                }
            })
        },

        errorAlert(params){
            if (getIsSessionInvalidated()) {
                return;
            }
            Swal.fire({
                title: '',
                html: params,
                confirmButtonText: '확인',
                customClass: !params.customClass ? 'alert-default' : params.customClass,
                didClose: () => {

                }
            })
        },
        backErrorAlert(params){
            if (getIsSessionInvalidated()) {
                return;
            }
            Swal.fire({
                title: '',
                html: params,
                confirmButtonText: '확인',
                willClose: () => {
                    window.history.back();
                }
            })
        },
        inputAlert(params) {
            if (getIsSessionInvalidated()) {
                return;
            }
            Swal.fire({
                title: !params.title ? '' : params.title,
                html: !params.content ? '' : params.content,
                input: 'text',
                inputPlaceholder:!params.placeHolder ? '' : params.placeHolder,
                confirmButtonText: !params.confirmText ? "확인" : params.confirmText,
                cancelButtonText: !params.cancelText ? "취소" : params.cancelText,
                showCancelButton: true,
                customClass: !params.customClass ? 'alert-default' : params.customClass,
            }).then((result) => {
                if (!result.dismiss) {
                    if (params.confirm) {
                        params.confirm(result.value);
                    }
                } else {
                    if (params.cancel) {
                        params.cancel();
                    }
                }
            })
        },
    }
}
